var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCheckBottomsheet = function SvgIconCheckBottomsheet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.707 7.293a1 1 0 0 1 0 1.414l-8.646 8.647a1.5 1.5 0 0 1-2.122 0l-3.646-3.647a1 1 0 1 1 1.414-1.414L9 15.586l8.293-8.293a1 1 0 0 1 1.414 0Z",
    fill: "#B37AFC"
  })));
};
export default SvgIconCheckBottomsheet;